export const LINE_REGULAR = 1
export const LINE_HOST_GIFT = 2
export const LINE_PROFILING = 4
export const LINE_DEMO = 5
export const LINE_ELEVATED_HOST_GIFT = 11
export const LINE_NORMAL = 0
export const IMAGE_EXTENSIONS = ['BMP','JPG','JPEG','GIF','PNG','RAW', 'TIFF']
